import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt } from '@fortawesome/free-solid-svg-icons/faAt';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { StateContext, StateContextType } from '../util/providers/StateProvider';
import { Link } from 'react-router';
import { requireImage, requireImageAsync } from '../util/require-image';
import { PageData } from './homepage/types';

export const Footer = (): ReactNode => {
  const intl: IntlShape = useIntl();
  const [mandantLogo, setMandantLogo] = useState<string | null>();
  const stateContext: StateContextType = useContext(StateContext);
  const pageData: PageData = stateContext.pageData;

  useEffect((): void => {
    void requireImageAsync(`Settings/mandants/${stateContext.originMandantSettings.mandant}/${pageData.footer.logo.svg}`)
      .then((result: string): void => setMandantLogo(result));
  }, [stateContext]);

  return (<>{!!pageData &&
      <footer className={'flex flex-column md:flex-row gap-5 p-3 surface-100 shadowed-reverse z-1'}>
        <div className={'flex md:flex-column justify-content-around gap-5'}>
          <div className={'w-20rem h-full md:px-3 align-content-center justify-content-center'}>
            <Link to={pageData.footer.logo.link} className={'block w-full h-full align-content-center justify-content-center'}>
              <img className={'w-full h-full'}
                   src={mandantLogo}
                   alt={pageData.footer.logo.alt}/>
            </Link>
          </div>
          {stateContext.originMandantSettings.usesOrcid && <div className={'w-20rem md:px-3 align-content-center justify-content-center'}>
            <a href={intl.formatMessage({id: 'layout.footer.orcid.logoLink'})}
               className={'block w-full h-full align-content-center justify-content-center'}>
              <img className={'w-full'} src={requireImage('Settings/img/logos/logo_orcid.svg')} alt="Orcid Logo"/>
            </a>
          </div>}
        </div>
        <div className={'flex md:justify-content-between flex-column gap-4 sm:mr-6'}>
          <div className={'flex flex-column gap-1'}>
            {(pageData.footer.email || []).length > 0 && pageData.footer.email.map((email: string, index: number) =>
              <a key={`mail${index}`} className={'text-primary no-underline'}
                 href={`mailto:${intl.formatMessage({id: email})}`}>
                <FontAwesomeIcon icon={faAt}/> <FormattedMessage id={email}/>
              </a>
            )}
            {(pageData.footer.phone || []).length > 0 && pageData.footer.phone.map((phone: string, index: number) =>
              <a key={`phone${index}`} className={'text-primary no-underline'}
                 href={`tel:${intl.formatMessage({id: phone})}`}>
                <FontAwesomeIcon icon={faPhone}/> <FormattedMessage id={phone}/>
              </a>
            )}
          </div>
          <div className={''}>
            <FormattedMessage id={pageData.footer.text}/>
          </div>
          <div className={'flex flex-column sm:flex-row justify-content-between gap-2'}>
            {pageData.footer.links.dataProtection && <div>
              <a className={'text-primary no-underline font-bold'}
                 target={'_blank'}
                 href={intl.formatMessage({id: `${stateContext.originMandantSettings.mandant}.footer.dataProtection_link`})}
                 rel="noreferrer"><FormattedMessage
                id="layout.footer.dataProtection"/></a>
            </div>}
            {pageData.footer.links.guidelines && <div>
              <a className={'text-primary no-underline font-bold'}
                 target={'_blank'}
                 href={intl.formatMessage({id: `${stateContext.originMandantSettings.mandant}.footer.guidelines_link`})}
                 rel="noreferrer"><FormattedMessage
                id="layout.footer.guidelines"/></a>
            </div>}
            {pageData.footer.links.imprint && <div>
              <a className={'text-primary no-underline font-bold'}
                 target={'_blank'}
                 href={intl.formatMessage({id: `${stateContext.originMandantSettings.mandant}.footer.imprint_link`})}
                 rel="noreferrer"><FormattedMessage
                id="layout.footer.imprint"/></a>
            </div>}
          </div>
        </div>
      </footer>}</>
  );
};

export default Footer;
